// import React, { useContext } from 'react';
// import ReactDOM from 'react-dom/client';

// import './index.css';

// import reportWebVitals from './reportWebVitals';

// import Header from './Components/Header';
// import Footer from './Components/Footer';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Home from './Pages/Home';
// import Error from './Pages/Error';
// import { createGlobalStyle } from 'styled-components';
// import { MenuProvider } from './utils/context';
// import { ThemeProvider } from './utils/context';
// import { ThemeContext } from './utils/context';
// import ThemeComp from './Components/ThemeButton';
// import { HelmetProvider } from 'react-helmet-async';
// import SEO from './Components/SEO';

// // ========================== IMPORT ROUTES ===========================
// import About from './Pages/About';
// import Contact from './Pages/Contact';
// import Devis from './Pages/Devis';
// import Boutique from './Pages/Boutique';
// import ProductPage from './Pages/Boutique/product/ProductDetail';
// import Checkout from './Pages/Boutique/checkout';


// const GlobalStyle = createGlobalStyle`
//   * {
//     margin: 0;
//     padding: 0;
//     box-sizing: border-box;
//     font-family: 'Google Sans', sans-serif;
//   }

//   body {
//     background-color: ${props =>
//     props.theme === 'light' ? '#f1f1f1' : '#2b2b2b'};
//     color: ${props => (props.theme === 'light' ? '#2e2e2e' : '#c5c5c5')};
//     transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
//     overflow-x: hidden;
//   }
// `;

// const GlobalStyleWithTheme = () => {
//   const { theme } = useContext(ThemeContext);
//   return <GlobalStyle theme={theme} />;
// };

// // ==================== DETECTION DU SOUS-DOMAINE ====================
// const hostname = window.location.hostname;
// // Détecte si on est sur store.safaridew.com ou store.localhost en développement
// const isStoreSubdomain = hostname.startsWith('store.');

// // const isStoreSubdomain = true; // Force le mode boutique pour tester le rendu visuel

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <ThemeProvider>
//       <Router>
//         <MenuProvider>
//           <HelmetProvider>
//             {/* Si on est sur le store, on peut mettre un SEO adapté ou laisser celui-là */}
//             <SEO
//               title={isStoreSubdomain ? "Safaridew - Boutique" : "Safaridew - startup studio"}
//               description="Découvrez nos produits sur la boutique officielle de Safaridew."
//               canonical={isStoreSubdomain ? "https://store.safaridew.com/" : "https://safaridew.com/"}
//             />
//             <ThemeComp />
//             <GlobalStyleWithTheme />

//             {/* N'affiche le Header du site principal QUE si on n'est PAS sur le store */}
//             {/* {!isStoreSubdomain && <Header />} */}
//             <Header />
//             <Routes>
//               {isStoreSubdomain ? (
//                 // ================= ROUTES DU SOUS-DOMAINE STORE =================
//                 <>
//                   {/* La racine "store.safaridew.com/" affiche directement la Boutique */}
//                   <Route path="/" element={<Boutique />} />
//                   <Route path="/checkout" element={<Checkout />} />
//                   <Route path="/:slug" element={<ProductPage />} />
//                   {/* Optionnel : Une page 404 spécifique au store ou réutiliser la tienne */}
//                   <Route path="*" element={<Error />} />
//                 </>
//               ) : (
//                 // ================= ROUTES DU SITE PRINCIPAL =================
//                 <>
//                   <Route path="/" element={<Home />} />
//                   <Route path="/Contact" element={<Contact />} />
//                   <Route path="/About" element={<About />} />
//                   <Route path="/Devis" element={<Devis />} />
//                   <Route path="/Boutique" element={<Boutique />} />
//                   <Route path="/Boutique/checkout" element={<Checkout />} />
//                   <Route path="/Boutique/:slug" element={<ProductPage />} />
//                   <Route path="*" element={<Error />} />
//                 </>
//               )}
//             </Routes>

//             {/* N'affiche le Footer du site principal QUE si on n'est PAS sur le store */}
//             {!isStoreSubdomain && <Footer />}

//           </HelmetProvider>
//         </MenuProvider>
//       </Router>
//     </ThemeProvider>
//   </React.StrictMode>,
// );

// reportWebVitals();

















import React, { useContext } from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import reportWebVitals from './reportWebVitals';

import Header from './Components/Header';
import Footer from './Components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Error from './Pages/Error';
import { createGlobalStyle } from 'styled-components';
import { MenuProvider } from './utils/context';
import { ThemeProvider } from './utils/context';
import { ThemeContext } from './utils/context';
import ThemeComp from './Components/ThemeButton';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './Components/SEO';

// ========================== IMPORT ROUTES ===========================
import About from './Pages/About';
import Contact from './Pages/Contact';
import Devis from './Pages/Devis';
import Boutique from './Pages/Boutique';
import ProductPage from './Pages/Boutique/product/ProductDetail';
import Checkout from './Pages/Boutique/checkout';


const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Google Sans', sans-serif;
  }

  body {
    background-color: ${props =>
    props.theme === 'light' ? '#f1f1f1' : '#2b2b2b'};
    color: ${props => (props.theme === 'light' ? '#2e2e2e' : '#c5c5c5')};
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    overflow-x: hidden;
  }
`;

// AOS removed

const GlobalStyleWithTheme = () => {
  const { theme } = useContext(ThemeContext); // Obtenez la valeur du thème à partir du contexte
  return <GlobalStyle theme={theme} />; // Passez le thème à votre GlobalStyle
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Router>
        <MenuProvider>
          <HelmetProvider>
            <SEO
              title="Safaridew - startup studio"
              description="Safaridew, startup studio: création web, SEO, marketing digital. Boostez votre présence en ligne."
              canonical="https://safaridew.vercel.app/"
            />
            <ThemeComp />
            <GlobalStyleWithTheme />
            <Header />
            {/* AOS removed */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="*" element={<Error />} />
              <Route path="/Contact" element={<Contact />} />
              <Route path="/About" element={<About />} />
              <Route path="/Devis" element={<Devis />} />
              <Route path="/Boutique" element={<Boutique />} />
              <Route path="/Boutique/checkout" element={<Checkout />} />
              <Route path="/Boutique/:slug" element={<ProductPage />} />
            </Routes>
            <Footer />
          </HelmetProvider>
        </MenuProvider>
      </Router>
    </ThemeProvider>
  </React.StrictMode>,
);

reportWebVitals();
